<template>
  <div class="appoint-input">
    <appoint-title
      :title="title"
      :isCheck="isCheck"
      :buttonKey="buttonKey"
      :buttonContent="buttonContent"
      @titleClick="titleClick"
    ></appoint-title>
    <div class="form-field">
      <van-field
        v-model="inputVal"
        :placeholder="placeholder"
        class="input"
        :type="type != 'textarea' ? 'text' : 'textarea'"
        :autosize="
          type != 'textarea' ? false : { maxHeight: height, minHeight: height }
        "
        :disabled="disabled"
        @keyup.native="handleChange"
        @blur="handleBlur"
        @change="onchange"
        :readonly="readonly"
        :style="{
          background: disabled ? '#EDEDED' : '#ffffff',
        }"
        style="flex: 2;"
      >
        <template #button v-if="type != ''">
          <div
            v-if="type == 'option' || type == 'select'"
            class="selectBtn"
            @click="onSelect"
          >
            选择
          </div>
          <van-icon
            v-if="type == 'time'"
            class="dateIcon"
            :name="require('@/assets/img/projectAppoint/dateTime.png')"
            size="18"
            @click="disabled ? '' : (showDate = true)"
          />
        </template>
      </van-field>
      <van-button class="field-btn" color="#1D84FF" 
        v-if="buttonContent" @click="titleClick({buttonKey:buttonKey})">
        {{buttonContent}}
      </van-button>
    </div>
    <van-popup v-model="showDate" position="bottom" v-if="type == 'time'">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title=""
        @confirm="dateConfirm"
        @cancel="showDate = false"
      />
    </van-popup>
    <van-popup
      v-model="showPicker"
      position="bottom"
      v-if="type == 'option' || type == 'select'"
    >
      <van-picker
        show-toolbar
        :columns="options"
        value-key="showValue"
        @confirm="onConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import AppointTitle from "./appoint-title.vue";
import commonApi from "@/utils/api/common";
export default {
  components: { AppointTitle },
  props: {
    title: {
      type: String,
      default: "",
    },
    value: {
      type: [String, Number],
      default: null,
    },
    placeholder: {
      type: String,
      default: "",
    },
    type: {
      //data,select,price,number
      type: String,
      default: "text",
    },
    height: {
      type: [String],
      default: "80",
    },
    isCheck: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    rules: {
      type: Boolean,
      default: false,
    },
    keyId: {
      type: String,
      default: "",
    },
    dictKey: {
      type: String,
      default: "",
    },
    titleButton: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      showDate: false,
      inputVal: this.value,
      currentDate: new Date(),
      showPicker: false,
      buttonKey: "",
      buttonContent: "",
      options: [],
    };
  },
  watch: {
    inputVal(val) {
      //必填项处理
      if (val) {
        this.handleRule(val);
        this.$emit("input", val);
      }
    },
    value(val) {
      this.inputVal = val;
    },
    titleButton: {
      handler(newVal) {
        this.buttonKey = newVal.key;
        this.buttonContent = newVal.label;
      },
      deep: true,
      immediate: true, // 第一次赋值也要触发监听
    },
  },
  computed: {
    readonly() {
      return (
        this.type == "option" || this.type == "select" || this.type == "time"
      );
    },
  },
  methods: {
    /**
     * 选择控件
     */
    onSelect() {
      if (!this.disabled) {
        if (this.type == "option") {
          //会弹出底部选择
          this.showPicker = true;
        }
        if (this.type == "select") {
          this.$emit("onSelect");
        }
      }
    },
    onConfirm(val) {
      this.inputVal = val.showValue;
      this.showPicker = false;
      // console.log(val.code, this.options)
      if(this.dictKey=='XMDDXZQ') {
        this.$parent.componentData.XZQCode = val.code
      }
      
    },
    dateConfirm(date) {
      if (!this.disabled) {
        this.inputVal = this.getFormatDate(date);
        this.showDate = false;
        this.$emit("input", this.inputVal);
      }
    },

    /**
     * @description: 日期格式化
     * @param {Srting,String}
     * @return: 返回格式化后的日期
     */
    getFormatDate(data) {
      if (!isNaN(data) && typeof data !== "object" && data.length > 4) {
        data = String(new Date());
      }
      const date = new Date(data);
      const year = date.getFullYear();
      let month = date.getMonth() + 1;
      let d = date.getDate();
      return `${year}-${month}-${d}`;
    },
    // 输入框改变时触发
    onchange() {
      this.$emit("input", this.inputVal);
    },
    // 输入时的处理：禁止输入非法字符（仅接受数字、小数点、负号）
    handleChange() {
      this.$emit("handleChange", this.keyId);
      if (!this.isNumber()) {
        return;
      }

      const n = String(this.inputVal);

      let tmp = "";
      if (n.indexOf("-") === 0) {
        tmp = "-"; // 如果是负数，先把负号保存起来
      }
      if (this.type === "number") {
        // 整数
        tmp += n.replace(/[^\d]/g, ""); // 只保留数字
      } else {
        //   tmp += n.replace(/[^\d]/g, '') // 只保留数字

        tmp += n.replace(/[^\d]/g, ""); // 保留数字和小数点
      }
      if (tmp.length > 9) {
        tmp = tmp.substring(0, 9);
      }
      this.inputVal = tmp;
      this.$emit("input", this.inputVal);

      if (this.validateEvent) {
        this.dispatch("SmFormItem", "sm.form.change", this.inputVal);
      }
    },
    // 失焦时的处理：零值处理、非法内容处理、保留小数位数处理
    handleBlur() {
      if (!this.isNumber()) {
        return;
      }
      let tmp = "";
      const n = this.inputVal;
      tmp += n.replace(/[^\d^.]/g, "");
      this.inputVal = tmp;
      console.log("blur1", parseFloat(tmp));
      if (!this.isNumber()) {
        return;
      }
      this.inputVal = isNaN(parseFloat(tmp)) ? "" : parseFloat(tmp); // parseFloat 过滤非法内容
      console.log("blur", tmp, this.inputVal);
      // 零值处理
      if (this.inputVal == "" && this.handleZero == "showNothing") {
        // console.log('this.inputVal 111===>', this.inputVal);
        this.inputVal = ""; // 处理内数据回填(cm)
        this.$emit("input", "");
        return;
      }
      if (this.inputVal == "" && this.handleZero == "showZero") {
        console.log("-----0-----");
        this.inputVal = 0;
      }
      // 处理toFixed
      if (this.type !== "number" && this.inputVal !== "") {
        this.inputVal = this.numFormat(this.inputVal);
        // this.inputVal = this.inputVal.toFixed(this.toFixed)
        console.log("toFixed", this.inputVal);
      }
      // 整数处理
      if (this.type === "number") {
        // this.handleChange()
        this.inputVal = this.inputVal.toFixed(0);
      }
      this.$emit("input", this.inputVal); // el-input接收 Number 类型会报错。
      if (this.validateEvent) {
        this.dispatch("SmFormItem", "sm.form.blur", this.inputVal);
      }
    },
    numFormat(num) {
      var c =
        num.toString().indexOf(".") !== -1
          ? num.toLocaleString()
          : num.toString().replace(/(\d)(?=(?:\d{3})+$)/g, "$1,") + ".00";
      return c;
    },
    isNumber() {
      if (this.type == "number" || this.type == "price") {
        return true;
      } else {
        return false;
      }
    },
    handleRule(val) {
      if (this.isCheck && val.length > 0) {
        this.$emit("update:rules", true);
      } else if (!this.isCheck) {
        this.$emit("update:rules", true);
      } else {
        this.$emit("update:rules", false);
      }
    },
    titleClick(val) {
      this.$emit("titleClick", val);
    },
    getDict(code) {
      commonApi.lookupDict({ code }).then((res) => {
        this.options = res.data;
      });
    },
  },
  created() {
    if (this.dictKey) this.getDict(this.dictKey);
  },
  mounted() {
    this.handleRule(this.inputVal);
  },
};
</script>
<style lang="scss" scoped>
.appoint-input {
  padding: 10px 0px;
  .form-field {
    display: flex;
    .input {
      border: 1px solid #dddddd;
      padding: 0px 10px;
      max-width: 100%;
      height: 42px;
      // line-height: 42px;
      display: flex;
      align-items: center;
      ::v-deep .van-field__control {
        font-size: 14px;
        font-weight: 500;
        color: #333333;
        line-height: normal;
      }
    }
    .field-btn {
      margin-left: 10px;
      padding: 0px 8px;
      height: 42px;
    }
  }
  
  .selectBtn {
    font-size: 14px;
    font-weight: 500;
    color: #1d84ff;
  }
  .dateIcon {
    // margin-right: 3px;
    // margin-top: 2px;
    position: absolute;
    top: 0px;
    right: 0px;
  }
}
</style>
